import { Environment } from './environment_type';

export const environment: Environment = {
  production: true,
  api_url: 'https://testzeegw.vemoit.com/fms/mex',
  gateway: 'https://testzeegw.vemoit.com',
  app_base_url: 'https://testfms.vemoit.com',
  environment: 'test',
  tenants: ['mex', 'lto'],
  routes: {
    mex: 'https://testzeegw.vemoit.com/fms/mex',
    lto: 'https://testzeegw.vemoit.com/fms/lto',
  },
};
